export const scrollElementIntoViewWithOffset = (element: Element, offset = 200) => {
  var rect = element.getBoundingClientRect();
  window.scrollTo({
    left: rect.left,
    top: rect.top - offset,
    behavior: 'smooth',
  });
};
